'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fal';
var iconName = 'cloud-showers-water';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'e4e4';
var svgPathData = 'M96 96c0-53 43-96 96-96 36 0 67.4 19.8 83.8 49.1 14.6-10.8 32.7-17.1 52.2-17.1 40.3 0 74.2 27.1 84.7 64l3.3 0c35.3 0 64 28.7 64 64s-28.7 64-64 64L96 224c-35.3 0-64-28.7-64-64S60.7 96 96 96zm96-64c-35.3 0-64 28.7-64 64 0 4.4 .4 8.7 1.3 12.8 1 4.7-.3 9.6-3.3 13.3s-7.6 5.9-12.4 5.9L96 128c-17.7 0-32 14.3-32 32s14.3 32 32 32l320 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-16.4 0c-8.2 0-15-6.1-15.9-14.2-3.1-28-26.8-49.8-55.7-49.8-18.6 0-35 9-45.2 23-3.7 5-10 7.5-16.1 6.2s-11-5.9-12.4-12C247.6 53 222.2 32 192 32zM85.1 272.8c8.4 2.8 12.9 11.9 10.1 20.2l-26.7 80c-2.8 8.4-11.9 12.9-20.2 10.1s-12.9-11.9-10.1-20.2l26.7-80c2.8-8.4 11.9-12.9 20.2-10.1zm120 0c8.4 2.8 12.9 11.9 10.1 20.2l-26.7 80c-2.8 8.4-11.9 12.9-20.2 10.1s-12.9-11.9-10.1-20.2l26.7-80c2.8-8.4 11.9-12.9 20.2-10.1zm112 0c8.4 2.8 12.9 11.9 10.1 20.2l-26.7 80c-2.8 8.4-11.9 12.9-20.2 10.1s-12.9-11.9-10.1-20.2l26.7-80c2.8-8.4 11.9-12.9 20.2-10.1zm120 0c8.4 2.8 12.9 11.9 10.1 20.2l-26.7 80c-2.8 8.4-11.9 12.9-20.2 10.1s-12.9-11.9-10.1-20.2l26.7-80c2.8-8.4 11.9-12.9 20.2-10.1zM338 469.9c-25.6 18.3-52.9 34.1-82 34.1s-56.4-15.8-82-34.1c-26-18.6-61.1-18.6-87.1 0-20 14.3-43.1 27.3-68 31.8-8.7 1.6-17-4.2-18.6-12.9s4.2-17 12.9-18.6c18.1-3.3 36.7-13.2 55.1-26.4 37.1-26.5 87.1-26.5 124.3 0 25.3 18.1 45.3 28.1 63.5 28.1s38.1-10.1 63.5-28.1c37.1-26.5 87.1-26.5 124.3 0 18.5 13.2 37 23.1 55.1 26.4 8.7 1.6 14.5 9.9 12.9 18.6s-9.9 14.5-18.6 12.9c-24.9-4.5-48-17.5-68-31.8-26-18.6-61.1-18.6-87.1 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCloudShowersWater = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;